export function formatPriceWithDollar(val) {
  if (val === undefined || val === null || val === '') return '$0.00';
  let num = Number(val.toString().replace(/[^\d.\-]/g, ''));
  if (isNaN(num)) return '$0.00';
  return '$' + num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
} 

export const toNumber = (v) => {
  if (v === '' || v === null || v === undefined) return 0;
  const str = v.toString();
  const cleaned = str.replace(/[^\d.-]/g, '');
  return cleaned ? Number(cleaned) : 0;
};

export function formatPercentage(val) {
  if (val === undefined || val === null || val === '') return '0%';
  let num = Number(val.toString().replace(/[^\d.\-]/g, ''));
  if (isNaN(num)) return '0%';
  return num.toFixed(4) + '%';
}

// Format percentage input with max 100 limit (for commission fields)
export function formatPercentageInput(val, maxValue = 100) {
  if (val === undefined || val === null || val === '') return '0';
  // Remove % sign if present
  let cleanValue = val.toString().replace('%', '').replace(/[^\d.\-]/g, '');
  let numValue = parseFloat(cleanValue);
  
  if (isNaN(numValue)) return '0';
  
  // Limit to max value
  if (numValue > maxValue) {
    numValue = maxValue;
  }
  
  // Limit to 0 if negative
  if (numValue < 0) {
    numValue = 0;
  }
  
  return numValue.toString();
}

// Display percentage value (add % sign when not focused)
export function displayPercentage(val, isFocused = false) {
  if (isFocused) {
    return formatPercentageInput(val);
  }
  const numVal = formatPercentageInput(val);
  return numVal + '%';
}